const nl = {
    actionAlready: "Nog niet geregistreerd? Inloggen",
    actionExit: "Uitloggen",
    actionLogin: "INLOGGEN",
    actionRegister: "AANMELDEN",
    actionSave: "OPSLAAN",
    actionStart: "STARTEN",
    actionContinue: "DOORGAAN",
    actionReset: "HERSTEL BEOORDELING",
    actionDoDiagnost: "TOON DIAGNOSTIEK",
    actionYes: "Ja",
    actionNo: "Nee",
    actionNext: "VOLGENDE",
    actionBusinessCase: "TOON GOEDE PRAKTIJK VAN HET BEDRIJF",
    actionBusinessCases: "TOON GOEDE PRAKTIJKEN VAN BEDRIJVEN",
    actionOpenUrl: "OPEN URL",
    actionFilter: "FILTEREN",

    /** HOME */
    msgHomeTitleOne: "Meet en verhoog het niveau van circulaire volwassenheid van uw meubelbedrijf",
    msgHomeSubTitle: "FurnCIRCLE Online Tool beoordeelt de vooruitgang van uw bedrijf naar circulaire volwassenheid op basis van de toegepaste circulaire ontwerpstrategieën",

    msgHomeSection2: "Circulaire vereisten breiden zich uit.</br>Ben je er klaar voor?",
    msgHomeSection2Text: "<ul style='padding-left: 20px'><li>Beantwoord de vragen over circulaire ontwerpstrategieën die momenteel in uw bedrijf worden toegepast.</li><li>Ontvang de circulaire volwassenheidsindex van uw bedrijf.</li><li>Identificeer ontwerpstrategieën en goede praktijken van bedrijven om uw bedrijf naar het volgende niveau te brengen.</li><li>Leer van de goede praktijken van echte bedrijven om het niveau van circulaire volwassenheid van uw bedrijf verder te verbeteren.</li></ul>",
    msgHomeSection3: "Partners",
    msgHomeSection2Btn: "Start uw beoordeling",
    msgHomeSection3Btn: "CONTACT",

    /** HEADER */
    msgHeader1: "Circulaire ontwerpstrategieën en goede praktijken",
    msgHeader4: "Inloggen",

    /** DRAWER */
    msgCompany: "BEDRIJF",
    msgDrawer1: "1. Beantwoorden",
    msgDrawer2: "2. Beoordelen",
    msgDrawer3: "3. Verbeteren",
    msgDrawer4: "Strategieën verzameling",
    msgDrawer6: "Instellingen",
    msgDrawer7: "Uitloggen",

    /** LOGIN */
    msgWelcome: "Welkom",
    msgWelcomeSubtitle: "Log in om door te gaan",

    /** REGISTER */
    msgGetStarted: "Begin nu",
    msgGetStartedSubtitle: "Deze zelfbeoordelings tool is gratis en vertrouwelijk",

    msgFirstname: "Voornaam",
    msgLastname: "Achternaam",
    msgEmail: "E-mail",
    msgPassword: "Wachtwoord",
    msgConfirmPassword: "Bevestig wachtwoord",
    msgCompanyUser: "Bedrijf of gebruikersnaam",

    msgNotRegister: "Nog niet geregistreerd? <b>Maak hier een account aan</b>",
    msgAlreadyRegister: "Al geregistreerd? <b>Log hier in</b>",

    /** HOME TOOL */
    msgClickImage: "Klik om het lineaire versus circulaire model systeem uit te breiden.",

    msgArea: "GEBIED",
    msgProgress: "BEANTWOORDE VRAGEN",

    msgAssessmentAreas: "Circulaire ontwerpstrategieën en levenscyclus van producten",
    msgAssessmentDesc: "Circulaire ontwerpstrategieën worden toegepast tijdens de ontwerp- en ontwikkelingsfase van producten, hoewel hun (positieve) impact kan plaatsvinden in een of meerdere latere fasen van de productlevenscyclus. Een manier om circulaire ontwerpstrategieën te classificeren is volgens de levenscyclusfase die wordt beïnvloed: ontwerp, materiaalbronnen, productie, distributie, gebruik en einde van de levensduur.<br/><br/><span style=\"font-weight:bold; font-size:16px;\">Beantwoord alstublieft alle vragen voor elk blok of fase van de levenscyclus, bepaal uw niveau van circulaire volwassenheid en plan uw verbetering en overgang naar een meer circulaire economie!</span>",

    msgAssessment: "FurnCIRCLE Beoordeling",
    msgNotApply: "Markeer alle antwoorden die van toepassing zijn op de huidige circulaire prestaties van uw bedrijf. Antwoorden worden automatisch opgeslagen.",
    msgMarkImportant: "Markeer als belangrijk",
    msgComment: "Opmerking",
    msgCommentHolder: "U kunt hier gerelateerde informatie of uw eigen opmerkingen schrijven.",

    /** ANSWER */
    msgPerformance: "Beoordelingsrapport",
    msgPerformanceSubtitle: "Bekijk de circulaire volwassenheidsindex van uw bedrijf en elke fase van de levenscyclus van uw producten.",
    msgCompanyLevel: "Circulaire volwassenheidsindex van uw bedrijf (0%-100%)",
    msgBlockArea: "LEVENSCYCLUS FASE",
    msgBlockValues: "WAARDEN",

    /** ASSESS */
    msgImprovement: "Verbeteringsrapport",
    msgImprovementMainSubtitle: "Leer wat u kunt doen om de circulaire prestaties van uw bedrijf voortdurend te verbeteren. Ken ontwerpstrategieën en goede praktijken van bedrijven om uw bedrijf naar het volgende niveau te brengen.</br></br>Levenscyclusfasen en circulaire ontwerpstrategieën met een “rood” label/cirkel hebben een prestatieniveau dat gelijk is aan of minder dan 25% van hun maximale waarde en kunnen daarom worden beschouwd als topprioriteit voor het verbeteren van de circulaire prestaties van het bedrijf. Fasens of strategieën met een “oranje” label/cirkel hebben een prestatieniveau hoger dan 25% en minder dan of gelijk aan 75% en moeten daarom ook worden aangepakt voor verbetering. Fasens of strategieën met een “groen” label/cirkel hebben een prestatieniveau groter dan 75% en zijn daarom minder urgent voor verbetering.",
    msgImprovementSubtitle: "Leer wat u kunt doen om de circulaire prestaties van uw bedrijf voortdurend te verbeteren. Ken ontwerpstrategieën en goede praktijken van bedrijven om uw bedrijf naar het volgende niveau te brengen.",
    msgLifecyclePhases: "Levenscyclusfasen",
    msgLifecycleIndex: "Fase circulaire index",
    msgActionsToImplement: "Te implementeren acties:",
    msgBaselineScore: "Mijn basis score",
    msgBusinessCaseEmpty: "Gefeliciteerd! U heeft al de belangrijkste strategieën in deze categorie geïmplementeerd",

    msgCat1: "ECONOMISCH EN ORGANISATORISCH",
    msgCat2: "MAATSCHAPPELIJK",
    msgCat3: "MILIEU",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Blader door de volledige collectie van circulaire ontwerpstrategieën en goede praktijken van bedrijven van het FurnCIRCLE project.",
    msgLifecyclePhase: "Levenscyclusfase",
    msgDifficulty: "Moeilijkheid van implementatie",
    msgBusinessDynamics: "Waardegeneratie of levering",
    msgBusinessFactors: "Waardepropositie / Kosten / Voordelen",

    /** SETTINGS */
    msgUserInfo: "Gebruikersinformatie",
    msgUserCredentials: "Gebruikersgegevens",

    /** MODAL */
    msgAreSure: "Weet je het zeker?",

    msgSuccess: "Gegevens succesvol bijgewerkt",
    msgDeleteSuccess: "Gegevens succesvol verwijderd",

    /** ALT TEXT */
    msgSaveCommentAlt: "Sla de “Opmerking” op. Het is niet nodig om de antwoorden op de vragen op te slaan; ze worden automatisch opgeslagen.",
    msgDifficultyAlt: "Dit label geeft de moeilijkheidsgraad aan van het implementeren van de circulaire ontwerpstrategie.",
    msgBusinessBlockAlt: "Dit label geeft aan welk bedrijfsblok van het CANVAS-model (Waardegeneratie of Waardelevering) wordt beïnvloed door de implementatie van de circulaire ontwerpstrategie.",
    msgImpactBlockAlt: "Dit label geeft aan welk impactblok van het CANVAS-model (Kosten, Voordelen of Waardepropositie) wordt beïnvloed door de implementatie van de circulaire ontwerpstrategie.",

    /** ERROR */
    errorOblData: "Vul alle verplichte velden in",
    errorEmailFormat: "E-mail formaat fout",
    errorUserIncorrect: "E-mail/wachtwoord incorrect",
    errorSend: "Communicatiefout, wacht alstublieft en probeer later opnieuw",
    errorLength: "Het aantal tekens is overschreden",
    errorPassSame: "Wachtwoorden komen niet overeen",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Wachtwoord herstellen",
    msgRecoveryPasswordSubtitle: "Voer uw e-mailadres in om een code voor het opnieuw instellen van uw wachtwoord te ontvangen.",
    msgCode: "Code",
    msgNewPassword: "Nieuw wachtwoord",
    actionRequestCode: "CODE AANVRAGEN",
    actionUpdate: "BIJWERKEN",
    actionBack: "TERUG",
    msgForgetPassword: "Wachtwoord vergeten?",
    errorRecovery: "Fout bij wachtwoordherstel, controleer de opgegeven code",

    /** FOOTER */
    msgFooterContact: "CONTACT",

    msgFooterGr: "Gefinancierd door de Europese Unie. De meningen en standpunten die worden uitgedrukt, zijn echter alleen die van de auteur(s) en weerspiegelen niet noodzakelijkerwijs die van de Europese Unie. Noch de Europese Unie, noch de verstrekker van de subsidie kan voor deze meningen verantwoordelijk worden gehouden. Call and Grant Agreement Reference: SOCPL-2022-SOC-DIALOG-01 (Project 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Alle rechten voorbehouden",

    msgFooterLegal: "Juridische kennisgeving",
    msgFooterPrivacy: "Privacy",
    msgFooterCookies: "Cookiebeleid",

    /** PROGRESS VALUES */
    msgProgress0: "Circulaire ontwerpstrategieën",

    /** COMPANY SIZES */
    msgCompanySize: "Grootte van het bedrijf",
    msgCompanySize1: "Minder dan 10 werknemers",
    msgCompanySize2: "10-30 werknemers",
    msgCompanySize3: "30-50 werknemers",
    msgCompanySize4: "Meer dan 50 werknemers",

    /** PRODUCT TYPES */
    msgProductType: "Type producten die u produceert",
    msgProductType1: "Bekleding",
    msgProductType2: "Matras",
    msgProductType3: "Bekledingsonderstellen, canapé's, bedbodems",
    msgProductType4: "Onderleverancier (frames, bewerking, lakken, enz.)",
    msgProductType5: "Diensten (gespecialiseerde logistiek, enz.)",
    msgProductType6: "Boardmeubilair (melamine, fineer, lak, enz.)",
    msgProductType7: "Houten meubels",
    msgProductType8: "Stoelen",
    msgProductType9: "Kantoor meubels",
    msgProductType10: "Meubels voor openbare ruimtes en toepassingen",
    msgProductType11: "Deuren, ramen en timmerwerkproducten",
    msgProductType12: "Aangepaste faciliteiten (winkels, bibliotheken, restaurants, professionele bedrijven, enz.)",
    msgProductType13: "Verlichting",
    msgProductType14: "Coatings en vloeren",
    msgProductType15: "Textiel",
    msgProductType16: "Decoraties",

    /* COUNTRIES */
    msgCountry: "Land",
    msgAfghanistan: "Afghanistan",
    msgAlbania: "Albanië",
    msgAlgeria: "Algerije",
    msgAmericanSamoa: "Amerikaans Samoa",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguilla",
    msgAntarctica: "Antarctica",
    msgAntiguaandBarbuda: "Antigua en Barbuda",
    msgArgentina: "Argentinië",
    msgArmenia: "Armenië",
    msgAruba: "Aruba",
    msgAustralia: "Australië",
    msgAustria: "Oostenrijk",
    msgAzerbaijan: "Azerbeidzjan",
    msgBahamas: "Bahama's",
    msgBahrain: "Bahrain",
    msgBangladesh: "Bangladesh",
    msgBarbados: "Barbados",
    msgBelarus: "Wit-Rusland",
    msgBelgium: "België",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermuda",
    msgBhutan: "Bhutan",
    msgBolivia: "Bolivia",
    msgBosniaHerzegovina: "Bosnië en Herzegovina",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Bouvet Island",
    msgBrazil: "Brazilië",
    msgBritishIndian: "Brits Indische Oceaanterritorium",
    msgBrunei: "Brunei",
    msgBulgaria: "Bulgarije",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Cambodja",
    msgCameroon: "Kameroen",
    msgCanada: "Canada",
    msgCapeVerde: "Kaapverdië",
    msgCaymanIslands: "Kaaimaneilanden",
    msgCentralAfrican: "Centraal-Afrikaanse Republiek",
    msgChad: "Tsjaad",
    msgChile: "Chili",
    msgChina: "China",
    msgChristmasIsland: "Kerstmis Eiland",
    msgCocosIslands: "Cocos (Keeling) Eilanden",
    msgColombia: "Colombia",
    msgComoros: "Comoren",
    msgCongo: "Congo",
    msgRepublicCongo: "De Democratische Republiek Congo",
    msgCookIslands: "Cookeilanden",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Ivoorkust",
    msgCroatia: "Kroatië",
    msgCuba: "Cuba",
    msgCyprus: "Cyprus",
    msgCzechRepublic: "Tsjechië",
    msgDenmark: "Denemarken",
    msgDjibouti: "Djibouti",
    msgDominica: "Dominica",
    msgDominicanRepublic: "Dominicaanse Republiek",
    msgEastTimor: "Oost-Timor",
    msgEcuador: "Ecuador",
    msgEgypt: "Egypte",
    msgEngland: "Engeland",
    msgElSalvador: "El Salvador",
    msgEquatorialGuinea: "Equatoriaal-Guinea",
    msgEritrea: "Eritrea",
    msgEstonia: "Estland",
    msgEthiopia: "Ethiopië",
    msgFalklandIslands: "Falklandeilanden",
    msgFaroeIslands: "Faeröer Eilanden",
    msgFijiIslands: "Fiji Eilanden",
    msgFinland: "Finland",
    msgFrance: "Frankrijk",
    msgFrenchGuiana: "Frans-Guyana",
    msgFrenchPolynesia: "Frans-Polynesië",
    msgFrenchSouthern: "Franse Zuidelijke en Antarctische Gebieden",
    msgGabon: "Gabon",
    msgGambia: "Gambia",
    msgGeorgia: "Georgië",
    msgGermany: "Duitsland",
    msgGhana: "Ghana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Griekenland",
    msgGreenland: "Groenland",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Guadeloupe",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Guinee",
    msgGuineaBissau: "Guinee-Bissau",
    msgGuyana: "Guyana",
    msgHaiti: "Haïti",
    msgHeardMcDonald: "Heard Island en McDonald Eilanden",
    msgHolySee: "Heilige Stoel (Vaticaanstad)",
    msgHonduras: "Honduras",
    msgHongKong: "Hong Kong",
    msgHungary: "Hongarije",
    msgIceland: "IJsland",
    msgIndia: "India",
    msgIndonesia: "Indonesië",
    msgIran: "Iran",
    msgIraq: "Irak",
    msgIreland: "Ierland",
    msgIsrael: "Israël",
    msgIsleMan: "Isle of Man",
    msgItaly: "Italië",
    msgJamaica: "Jamaica",
    msgJapan: "Japan",
    msgJersey: "Jersey",
    msgJordan: "Jordanië",
    msgKazakhstan: "Kazachstan",
    msgKenya: "Kenia",
    msgKiribati: "Kiribati",
    msgKuwait: "Koeweit",
    msgKyrgyzstan: "Kirgizië",
    msgLaos: "Laos",
    msgLatvia: "Letland",
    msgLebanon: "Libanon",
    msgLesotho: "Lesotho",
    msgLiberia: "Liberia",
    msgLibyanJamahiriya: "Libische Arabische Jamahiriya",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Litouwen",
    msgLuxembourg: "Luxemburg",
    msgMacao: "Macao",
    msgNorthMacedonia: "Noord-Macedonië",
    msgMadagascar: "Madagaskar",
    msgMalawi: "Malawi",
    msgMalaysia: "Maleisië",
    msgMaldives: "Maldiven",
    msgMali: "Mali",
    msgMalta: "Malta",
    msgMarshallIslands: "Marshall Eilanden",
    msgMartinique: "Martinique",
    msgMauritania: "Mauritanië",
    msgMauritius: "Mauritius",
    msgMayotte: "Mayotte",
    msgMexico: "Mexico",
    msgMicronesia: "Micronesië, Federale Staten van",
    msgMoldova: "Moldavië",
    msgMonaco: "Monaco",
    msgMongolia: "Mongolië",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Montenegro",
    msgMorocco: "Marokko",
    msgMozambique: "Mozambique",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibië",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Nederland",
    msgNetherlandsAntilles: "Nederlands-Antillen",
    msgNewCaledonia: "Nieuw-Caledonië",
    msgNewZealand: "Nieuw-Zeeland",
    msgNicaragua: "Nicaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigeria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Norfolk Eiland",
    msgNorthKorea: "Noord-Korea",
    msgNorthernIreland: "Noord-Ierland",
    msgNorthernMariana: "Noordelijke Marianen",
    msgNorway: "Noorwegen",
    msgOman: "Oman",
    msgPakistan: "Pakistan",
    msgPalau: "Palau",
    msgPalestine: "Palestina",
    msgPanama: "Panama",
    msgPapua: "Papoea-Nieuw-Guinea",
    msgParaguay: "Paraguay",
    msgPeru: "Peru",
    msgPhilippines: "Filipijnen",
    msgPitcairn: "Pitcairn",
    msgPoland: "Polen",
    msgPortugal: "Portugal",
    msgPuertoRico: "Puerto Rico",
    msgQatar: "Qatar",
    msgReunion: "Réunion",
    msgRomania: "Roemenië",
    msgRussianFederation: "Russische Federatie",
    msgRwanda: "Rwanda",
    msgSaintHelena: "Sint-Helena",
    msgSaintKitts: "Saint Kitts en Nevis",
    msgSaintLucia: "Saint Lucia",
    msgSaintPierre: "Saint Pierre en Miquelon",
    msgSaintVincent: "Saint Vincent en de Grenadines",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "São Tomé en Principe",
    msgSaudiArabia: "Saoedi-Arabië",
    msgScotland: "Schotland",
    msgSenegal: "Senegal",
    msgSerbia: "Servië",
    msgSeychelles: "Seychellen",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Singapore",
    msgSlovakia: "Slovenië",
    msgSlovenia: "Slovenië",
    msgSolomonIslands: "Salomonseilanden",
    msgSomalia: "Somalië",
    msgSouthAfrica: "Zuid-Afrika",
    msgSouthSandwich: "Zuid-Georgië en de Zuidelijke Sandwicheilanden",
    msgSouthKorea: "Zuid-Korea",
    msgSouthSudan: "Zuid-Soedan",
    msgSpain: "Spanje",
    msgSriLanka: "Sri Lanka",
    msgSudan: "Soedan",
    msgSuriname: "Suriname",
    msgSvalbardJan: "Svalbard en Jan Mayen",
    msgSwaziland: "Swaziland",
    msgSweden: "Zweden",
    msgSwitzerland: "Zwitserland",
    msgSyria: "Syrië",
    msgTajikistan: "Tadzjikistan",
    msgTanzania: "Tanzania",
    msgThailand: "Thailand",
    msgTimorLeste: "Timor-Leste",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad en Tobago",
    msgTunisia: "Tunesië",
    msgTurkey: "Turkije",
    msgTurkmenistan: "Turkmenistan",
    msgTurksCaicos: "Turkse Eilanden en Caicoseilanden",
    msgTuvalu: "Tuvalu",
    msgUganda: "Oeganda",
    msgUkraine: "Oekraïne",
    msgUnitedArabEmirates: "Verenigde Arabische Emiraten",
    msgUnitedKingdom: "Verenigd Koninkrijk",
    msgUnitedStates: "Verenigde Staten",
    msgUnitedStatesMinor: "Verenigde Staten Minor Outlying Islands",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Oezbekistan",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnam",
    msgVirginIslandsBritish: "Britse Maagdeneilanden",
    msgVirginIslandsUS: "Amerikaanse Maagdeneilanden",
    msgWales: "Wales",
    msgWallisFutuna: "Wallis en Futuna",
    msgWesternSahara: "Westelijke Sahara",
    msgYemen: "Jemen",
    msgZambia: "Zambia",
    msgZimbabwe: "Zimbabwe",
}

export default nl;